"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var gateway_module_1 = require("../gateway-module");
var AnalysisModule = /** @class */ (function (_super) {
    __extends(AnalysisModule, _super);
    function AnalysisModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnalysisModule.prototype.ownerMonthlyBillReport = function (params, token) {
        return this.gatewayClient.ownerMonthlyBillReport(params, token);
    };
    /**
     * 修改单条业主营收月结数据
     * @param checkRoomIncome 核查房费收入
     * @param id ID
     * @param roomPresented 本月可提现
     * @param lastMonthBalance 上月结余
     */
    AnalysisModule.prototype.updateOwnerRoomMonth = function (params, token) {
        return this.gatewayClient.updateOwnerRoomMonth(params, token);
    };
    /**
     * 修改单条房间月结数据
     * @param roomPresented 房间可提现
     * @param invoiceTax 发票税费
     * @param miscellaneousExpenses 其它杂项费
     * @param manageMoney	 运营费
     * @param checkRoomIncome 核查渠房间收入
     * @param checkLinenWashMoney 洗涤费核查
     * @param checkConsumableMoney 核查易耗品
     * @param checkCleanCostMoney 核查清洁单费
     * @param checkXbedPlatformMoney 核查平台费
     * @param transactionFee 交易手续费
     * @param checkOwnerPromotionExpense 核查业主推广费
     * @param checkOtaPlatformMoney 核查渠道分销费
     * @param checkRoomPayable 核查房费应付
     * @param checkOwnerDiscount 核查业主优惠
     * @param checkRoomOriMoney 核查房费原价
     */
    AnalysisModule.prototype.updateReRoomMonthIncome = function (params, token) {
        return this.gatewayClient.updateReRoomMonthIncome(params, token);
    };
    /**
     * 渠道分析
     * @param channelId 标识
     * @param startDate 开始时间格式yyyy-MM-dd （非空）
     * @param endDate 结束时间格式yyyy-MM-dd （非空）
     * @param page 页数
     * @param pageSize 每页数量
     * @param token 用户标识
     */
    AnalysisModule.prototype.getAnalysisChannelList = function (params, token) {
        return this.gatewayClient.getAnalysisChannelList(params, token);
    };
    return AnalysisModule;
}(gateway_module_1.GatewayModule));
exports.AnalysisModule = AnalysisModule;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvYXBpcy9vbXMvbW9kdWxlcy9hbmFseXNpcy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7QUFFQSxvREFBa0Q7QUFFbEQ7SUFBb0Msa0NBQWE7SUFBakQ7O0lBK0ZBLENBQUM7SUE5RlEsK0NBQXNCLEdBQTdCLFVBQ0UsTUFNQyxFQUNELEtBQWE7UUFFYixNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxzQkFBc0IsQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDbEUsQ0FBQztJQUVEOzs7Ozs7T0FNRztJQUNJLDZDQUFvQixHQUEzQixVQUNFLE1BTUMsRUFDRCxLQUFhO1FBRWIsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsb0JBQW9CLENBQUMsTUFBTSxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQ2hFLENBQUM7SUFFRDs7Ozs7Ozs7Ozs7Ozs7Ozs7T0FpQkc7SUFDSSxnREFBdUIsR0FBOUIsVUFDRSxNQWdCQyxFQUNELEtBQWE7UUFFYixNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyx1QkFBdUIsQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDbkUsQ0FBQztJQUNEOzs7Ozs7OztPQVFHO0lBQ0ksK0NBQXNCLEdBQTdCLFVBQ0UsTUFNQyxFQUNELEtBQWE7UUFFYixNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxzQkFBc0IsQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDbEUsQ0FBQztJQUNILHFCQUFDO0FBQUQsQ0FBQyxBQS9GRCxDQUFvQyw4QkFBYSxHQStGaEQ7QUEvRlksd0NBQWMifQ==


//////////////////
// WEBPACK FOOTER
// ./node_modules/xbed-api/lib/apis/oms/modules/analysis/index.js
// module id = 214
// module chunks = 44